import loadable from '@loadable/component'
import {RouteConfig} from 'react-router-config'

export default [
  {
    path: '/tiktok',
    exact: true,
    component: loadable(
      () =>
        import(/* webpackChunkName: "page-tiktok-hiya" */ '~/pages/TikTok/hiya')
    ),
  },
  {
    path: '/tiktok/game',
    exact: true,
    component: loadable(
      () =>
        import(/* webpackChunkName: "page-tiktok-game" */ '~/pages/TikTok/game')
    ),
  },
] as RouteConfig[]
